import { defineMessages } from 'react-intl';

export default defineMessages({
  invalid: {
    id: 'app.components.FlexChoices.invalid',
    defaultMessage: 'Item obrigatório',
  },
  type: {
    id: 'app.components.FlexChoices.type',
    defaultMessage: 'Tipo de contato',
  },
  tipoPorteiro: {
    id: 'app.components.FlexChoices.tipoPorteiro',
    defaultMessage: 'Portaria',
  },
  tipo: {
    id: 'app.components.FlexChoices.tipo',
    defaultMessage: 'Tipo de imóvel',
  },
  apartment: {
    id: 'app.components.FlexChoices.apartment',
    defaultMessage: 'Apartamento',
  },
  house: {
    id: 'app.components.FlexChoices.house',
    defaultMessage: 'Casa',
  },
  condoHouse: {
    id: 'app.components.FlexChoices.condoHouse',
    defaultMessage: 'Casa em condomínio',
  },
  studio: {
    id: 'app.components.FlexChoices.studio',
    defaultMessage: 'Kitnet / studio',
  },
  diaTodo: {
    id: 'app.components.FlexChoices.diaTodo',
    defaultMessage: '24 horas',
  },
  noturno: {
    id: 'app.components.FlexChoices.noturno',
    defaultMessage: 'Noturno',
  },
  diurno: {
    id: 'app.components.FlexChoices.diurno',
    defaultMessage: 'Diurno',
  },
  semPortaria: {
    id: 'app.components.FlexChoices.semPortaria',
    defaultMessage: 'Não há portaria',
  },
  sindico: {
    id: 'app.components.FlexChoices.sindico',
    defaultMessage: 'Síndico',
  },
  porteiro: {
    id: 'app.components.FlexChoices.porteiro',
    defaultMessage: 'Porteiro',
  },
  administradora: {
    id: 'app.components.FlexChoices.administradora',
    defaultMessage: 'Administradora',
  },
});
